import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { BsInstagram, BsGithub, BsLinkedin } from "react-icons/bs";
import { MdDoneAll } from "react-icons/md";
const Contact = () => {
  const form = useRef();
  const [name, setName] = useState("");
  const [submit, setSubmit] = useState(false);
  const sendMail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_o92vsx1",
        "template_7r6cco4",
        form.current,
        "sqF8YRVB4BtlY3WQK"
      )
      .then((res) => res.status === 200 && form.current.reset())
      .catch((e) => console.log(e));
    setSubmit(true);
  };
  return (
    <div
      className="min-h-[80vh] mt-20 flex flex-col justify-evenly items-center"
      id="contact"
    >
      <div className="text-5xl font-extralight text-blue-400 border-b-4  border-blue-400">
        Contact Me
      </div>
      {/* <div className="h-1 w-56 bg-blue-400 relative bottom-10" /> */}
      <div className="parent flex items-center justify-between w-screen px-4">
        <div className="left w-full">
          {submit ? (
            <div className=" w-full h-[274px] flex justify-center items-center text-4xl">
              <div className="flex bg-blue-400 h-40 w-[40rem] items-center justify-center text-white rounded-md">
                <p className="flex justify-center items-center px-4 animate-bounce pl-10 ">
                  <MdDoneAll className=" text-5xl mr-6 animate-ping" />
                  Submittedd succesfully
                </p>
              </div>
            </div>
          ) : (
            <form
              ref={form}
              onSubmit={sendMail}
              className="flex flex-col items-center justify-evenly"
            >
              <div className="flex lg:flex-row flex-col justify-evenly items-center w-[60%]">
                <div className="flex flex-col justify-around items-center mr-0 lg:mr-4 xl:mr-0 text-blue-400">
                  <div className=" my-4">
                    <input
                      className="border-[0.25rem] p-2 h-14 w-[20rem] lg:w-64 shadow-md focus:shadow-lg border-blue-300 focus:shadow-blue-500 outline-none shadow-blue-200 duration-500"
                      type="text"
                      placeholder="Your Name"
                      name="from_name"
                      required
                    />
                  </div>
                  <div className=" my-4">
                    <input
                      className="border-[0.25rem] p-2 h-14 w-[20rem] lg:w-64 shadow-md focus:shadow-lg border-blue-300 focus:shadow-blue-500 outline-none shadow-blue-200 duration-500"
                      type="email"
                      placeholder="Your Email"
                      name="from_email"
                      required
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className=" my-4">
                  <textarea
                    className="text-blue-400 resize-none border-[0.25rem] p-2 h-40 w-[20rem] shadow-md focus:shadow-lg border-blue-300 focus:shadow-blue-500 outline-none shadow-blue-200 duration-500"
                    type="text"
                    placeholder="Enter a message"
                    required
                    name="message"
                  />
                </div>
              </div>
              <div className="mt-8">
                <button
                  // onClick={() => {
                  //   setSubmit(true);
                  // }}
                  type="submit"
                  className="uppercase text-sm font-bold tracking-wide bg-bgRed text-white hover:-translate-y-1 duration-500 hover:bg-blue-200 hover:text-blue-700 shadow-md hover:scale-[1.1] hover:shadow-lg shadow-blue-200 hover:shadow-blue-500 bg-blue-500 p-3 rounded-lg w-full focus:outline-none"
                >
                  Send Message
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
      <div className="relative flex text-3xl left-[31vw] sm:left-[38vw] md:left-[40vw] lg:left-[43vw] xl:left-[45vw] bottom-0 sm:-bottom-4 md:-bottom-5 lg:-bottom-10 text-red-400">
        <BsInstagram className="mx-2 cursor-pointer hover:animate-pulse hover:text-blue-600" />
        <BsGithub className="mx-2 cursor-pointer hover:animate-pulse hover:text-blue-600" />
        <BsLinkedin className="mx-2 cursor-pointer hover:animate-pulse hover:text-blue-600" />
      </div>
    </div>
  );
};
export default Contact;
